import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.536}
    height={25.989}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18500 18828"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:208.645}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974541843936">
        <path
          d="M9377 13778c-2146 0-2308-2618-1309-2618h2327c467 0 263 47 420 307 546 907-524 2311-1438 2311zM7922 6505c3729 0 2695-308 4392 845 466 317 840 558 1311 871 471 315 837 559 1309 873l1280 902H2395l5527-3491zm2473-1164H7922c261-492 577-925 1183-974 210-17 709 144 862 235 365 218 386 223 428 739zM8650 3304c-1048 245-1623 936-1848 1934-192 851-379 822-2087 1842-432 258-752 467-1155 735C436 9895-382 9617 358 11160h6110c-787 3379 2763 4759 4739 2993 1282-1145 833-2464 788-2993h6110c121-253 291-646 291-1019 0-401-6281-4014-6672-4819-316-648-74-674-629-1263-369-392-695-618-1282-755V104H8650v3200zM8650 18724h1163v-2619H8650zM10686 16542c485 724 1166 1208 1309 1745 602-50 750-325 1019-727-183-273-468-599-706-895-274-342-544-616-894-851l-728 728zM5450 17560l694 760 1633-1778c-269-402-416-678-1018-728-150 562-641 747-1309 1746z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
